<template>
    <div class="right-container">
        <p class="right-h2">关于JS</p>
        <p class="right-h3">严格模式</p>
        <p class="right-content">由于 JavaScript 语法不够严谨，一直被人们所诟病，例如在使用一个变量时，可以不使用 var 关键字来提前声明，此时 JavaScript 解释器会自动为您创建这个变量。为了使代码更加严谨，JavaScript 中引入了严格模式，一旦使用了严格模式，将不再允许使用那些不严谨的语法。</p>
        <p class="right-content">严格模式具体限制了什么可以看 <a href="https://c.biancheng.net/view/9374.html" target="_blank">这里</a></p>
        <p class="right-content">实例如下：</p>
        <div class="right-code">
            <pre>
                <code class="language-js line-numbers" v-html="code.js.js1"></code>
            </pre>
        </div>
        <p class="right-h3">代码风格规范</p>
        <div class="right-code">
            <pre>
                <code class="language-js line-numbers" v-html="code.js.js2"></code>
            </pre>
        </div>
        <p class="right-content">当一段代码嵌套超过3层时，那么就代表这段代码是混乱的，这个时候就要尽可能地去优化代码。</p>
        <p class="right-h3">不使用eval()函数</p>
        <p class="right-content">就如 <code>eval</code> 的字面意思来说，恶魔，使用 <code>eval()</code> 函数会带来安全隐患。</p>
        <p class="right-content"><code>eval()</code> 函数的作用是返回任意字符串，当作js代码来处理。</p>
        <p class="right-h3">this关键字</p>
        <p class="right-content">只在对象构造器、方法和在设定的闭包中使用 <code>this</code> 关键字。<code>this</code> 的语义在此有些误导。它时而指向全局对象（大多数时），时而指向调用者的定义域（在 eval 中），时而指向 DOM 树中的某一节点（当用事件处理绑定到 HTML 属性上时），时而指向一个新创建的对象（在构造器中），还时而指向其它的一些对象（如果函数被 <code>call()</code> 和 <code>apply()</code> 执行和调用时）。</p>
        <p class="right-content">正因为它是如此容易地被搞错，请限制它的使用场景：</p>
        <ul>
            <li>在构造函数中</li>
            <li>在对象的方法中（包括由此创建出的闭包内）</li>
        </ul>
    </div>
</template>

<script>
import code from '../../utils/code'
import Prism from 'prismjs'
import 'prismjs/themes/prism.css'
export default {
    name: 'js',
    data () {
        return {
            code: code
        }
    },
    mounted () {
        Prism.highlightAll()
    }
}
</script>

<style lang="scss" scoped>

</style>